import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';

// Modules
import { SharedModule } from '../shared/shared.module';

// Routes
import { BUSINESS_ROUTES } from './business.routes';

// Components
import { BusinessComponent } from './business.component';
import { PTUComponent } from './components/ptu/ptu.component';
import { PDAComponent } from './components/pda/pda.component';
import { PTMComponent } from './components/ptm/ptm.component';
import { PTMIntermediateComponent } from './components/ptm-intermediate/ptm-intermediate.component';
import { PDComponent } from './components/pd/pd.component';
import { AfiliatesComponent } from './components/afiliates/afiliates.component';
import { UpAnalyticsComponent } from './components/up-analytics/up-analytics.component';

@NgModule({
  declarations: [
    BusinessComponent,
    PTUComponent,
    PDAComponent,
    PTMComponent,
    PTMIntermediateComponent,
    PDComponent,
    AfiliatesComponent,
    UpAnalyticsComponent
  ],
  imports: [
    CommonModule,
    BUSINESS_ROUTES,
    SharedModule,
    MarkdownModule
  ],
  exports: [
  ],
  providers: [],
})
export class BusinessModule {}
